<template>
  <div id="product">
    <div class="product-top">
      <div class="product-top-inner">
        <div class="product-top-inner-title">
          <h2>GPS定位终端LK900-A加强版</h2>
          <span>GPS和AGPS双定位&nbsp;|&nbsp;待机时间长 |&nbsp;强磁吸附</span>
        </div>
      </div>
    </div>
    <div class="product-advantage">
      <div class="product-advantage-public">
        <h2><i></i>产品特性<i></i></h2>
        <p>定位准确，及时报告到达目的地所需距离，适用于各种物流运输</p>
      </div>
      <div class="product-advantage-list">
        <div class="product-advantage-list-icon" v-for="item in special">
          <div class="advantage-item" v-for="items in item.listL">
            <div class="advantage-r advantages-r">
              <h3>{{items.title}}</h3>
            </div>
            <div class="advantage-l">
              <i class="iconfont" :class="items.icon"></i>
            </div>
          </div>
        </div>
        <div class="product-advantage-list-img">
          <img src="../../../static/images/product/product_mashine1.png" alt="产品图片">
        </div>
        <div class="product-advantage-list-icon" v-for="item in special">
          <div class="advantage-item" v-for="items in item.listR">
            <div class="advantage-l">
              <i class="iconfont" :class="items.icon"></i>
            </div>
            <div class="advantage-r">
              <h3>{{items.title}}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="product-parameter">
      <div class="product-advantage-public">
        <h2><i></i>产品参数<i></i></h2>
        <p>防水防尘，小巧轻便，待机时间长</p>
      </div>
      <ul class="product-parameter-list">
        <li v-for="item in parameter">
          <div class="product-parameter-list-l">{{item.title}}</div>
          <div class="product-parameter-list-r">{{item.txt}}</div>
        </li>
      </ul>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import Footer from "../global/footer"
  export default {
    name: "Product",
    data() {
      return {
        special: [{
          listL: [{
            id: 1,
            icon: "icon-dongtai",
            title: "基站定位"
          }, {
            id: 2,
            icon: "icon-map",
            title: "实时定位",
          }, {
            id: 3,
            icon: "icon-viewgallery",
            title: "电子栅栏",
          }, {
            id: 4,
            icon: "icon-logistic-logo",
            title: "GPS/AGPS双定位",
          }],

          listR: [{
            id: 5,
            icon: "icon-packing-labeling",
            title: "移位报警",
          }, {
            id: 6,
            icon: "icon-remind",
            title: "脱落报警",
          }, {
            id: 7,
            icon: "icon-iconset0250",
            title: "低电报警",
          }, {
            id: 8,
            icon: "icon-sorting",
            title: "多种工作模式",
          }]
        }],

        parameter: [{
          id: 1,
          title: "外壳材料",
          txt: "高强度ABS塑料"
        }, {
          id: 2,
          title: "通信制式",
          txt: "支持多种网络通信"
        }, {
          id: 3,
          title: "外形尺寸",
          txt: "120*64*35mm"
        }, {
          id: 4,
          title: "产品净重",
          txt: "175g"
        }, {
          id: 5,
          title: "4G模块",
          txt: "EC200S/A7670C可选"
        }, {
          id: 6,
          title: "正常工作温度",
          txt: "-20°C~ +55°C"
        }, {
          id: 7,
          title: "续航能力",
          txt: "720次上报"
        }, {
          id: 8,
          title: "定位方式",
          txt: "LBS基站/GPS定位可选"
        }, {
          id: 9,
          title: "防护等级",
          txt: "IP67 等级防尘、防水"
        }, {
          id: 10,
          title: "安装",
          txt: "强力魔术贴"
        }, {
          id: 11,
          title: "上报间隔范围",
          txt: "5分钟至24小时，上报间隔可调"
        },  {
          id: 12,
          title: "指示灯",
          txt: "绿灯闪上线定位，蓝灯闪烁GPS定位"
        }, {
          id: 13,
          title: "认证证书",
          txt: "3C，CE等"
        }, {
          id: 14,
          title: "优势特点",
          txt: "可重复使用、可充电"
        }, {
          id: 15,
          title: "激活",
          txt: "开机上线即用"
        }, {
          id: 16,
          title: "续航时间",
          txt: "3小时报一次，可续航90天以上"
        }]
      }
    },
    
    components: {
      Footer
    }
  }
</script>

<style>
  .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
    border-bottom: none !important;
  }
</style>

<style scoped>
  @import "./pro/product.css";
  @import "../../../static/font/iconfont.css";
  .product-top {
    width: 100%;
    height: 320px;
    background: url(../../../static/images/product/prodcut_bg1.jpg) no-repeat;
    background-position: center top;
  }
  .advantage-item {
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/product1.vue